import { createContext, useEffect, useState, useMemo, useContext, useRef} from 'react';
import { useLocation, useNavigate, useParams} from 'react-router-dom';
import { useLocalStorage } from "../utils/useLocalStorage";
import { useSessionStorage } from "../utils/useSessionStorage";

import * as FirestoreService from '../services/firestore';

import {getLocalidadePorCodigo, getEleicaoPorCodigo, 
        getCargoPorCodigo, getZePorNrZona, 
        getLocalVotaPorIdLocal} from '../utils/utils'

import RouteContext from '../hooks/RouteContext'

const AppContext = createContext();

//export default AppContext;
export const AppContextProvider  = (props) => {
       
  const mock=process.env.REACT_APP_MOCK_DATA ==="true";
  const {routeName, rotaVotacao, rotaSecoes, rotaAcompanhamento, rotaPendencias, rotaMapa, rotaLogin, rotaError} = useContext(RouteContext);
  
  //config
  const [rolagemAuto, setRolagemAuto] = useSessionStorage("rolagemAuto", false);
  const [rolagemAutoIntervalo, setRolagemAutoIntervalo] = useSessionStorage("rolagemAutoIntervalo", process.env.REACT_APP_SCROOL_STEP_TIME||0);
  const [ordenaPorVoto, setOrdenaPorVoto] = useSessionStorage("ordenaPorVoto", false);
  const [ocultaZonasConcluidas, setOcultaZonasConcluidas] = useSessionStorage("ocultaZonasConcluidas", false);
  const [ocultaLidas, setOcultaLidas] = useSessionStorage("ocultaLidas", true);
  const [ocultaNLidas, setOcultaNLidas] = useSessionStorage("ocultaNaoLidas", true);

  //dados usuarios
  const [user, setUser] = useLocalStorage("user", null);

  //dados totalizacao
  const [totalizacao, setTotalizacao] = useState();
  const [acompanhamentoSecoes, setAcompanhamentoSecoes] = useState();
  const [pendencias, setPendencias] = useState();
  const [fotos, setFotos] = useLocalStorage("fotosCand", []);
  
  //loader state
  const [loading, setLoading] = useState(true)
  
  //instancia
  const [instancia, setInstancia] = useSessionStorage("instancia", null);
  const [instanciaInfo, setInstanciaInfo] = useSessionStorage("instanciaInfo", null);

  //dados básicos - Lista dados dos filtros  
  const [eleicoes, setEleicoes] = useSessionStorage("eleicoes", []);
  const [localidades, setLocalidades] = useSessionStorage("localidades", []);
  const [ufs, setUfs] = useSessionStorage("ufs", []);
  const [cargos, setCargos] = useSessionStorage("cargos", []);
  const [zonasEleitorais, setZonasEleitorais] = useSessionStorage("zonasEleitorais", []);
  const [locaisVotacao, setLocaisVotacao] = useSessionStorage("locaisVotacao", []);
  
  //IDs dos Filtros selecionados
  const [localidadeSelecionadaId, setLocalidadeSelecionadaId] = useState(null);
  const [cargoSelecionadoId, setCargoSelecionadoId] = useState(null);
  const [zonaESelecionadaId, setZonaESelecionadaId] = useState(null);
  const [localVSelecionadoId, setLocalVSelecionadoId] = useState(null);
    
  const localidadeSelecionada = useMemo(
    () => getLocalidadePorCodigo(localidades,ufs, localidadeSelecionadaId) ,
    [localidadeSelecionadaId, localidades, ufs]
  );
  const cargoSelecionado = useMemo(
    () => getCargoPorCodigo(cargos, cargoSelecionadoId) ,
    [cargoSelecionadoId, cargos]
  );
  const zonaESelecionada = useMemo(
    () => getZePorNrZona(zonasEleitorais, zonaESelecionadaId) ,
    [zonaESelecionadaId, zonasEleitorais]
  );
  const localVSelecionado = useMemo(
    () => getLocalVotaPorIdLocal(locaisVotacao, localVSelecionadoId) ,
    [localVSelecionadoId, locaisVotacao]
  );

  //location  
  const navigate = useNavigate();

  useEffect(() => {    
    FirestoreService.onAuthChange(setUser)    
  }, []);

  useEffect(() => {
    if(rotaPendencias || rotaLogin){      
      //Rotas Protegidas redireciona para o logout caso não tenha usuario ativo
      if(!user){
        logout()
      }      
    }
  }, [user]);

  //Carrega dados compartilhados do sistema
  useEffect(() => {

    try{
      if(instancia){             

        if(!instanciaInfo || !FirestoreService.hasInstanciaInfoSubscribe()){
          FirestoreService.getInstanciaInfo(mock,instancia,setInstanciaInfo,setUfs,setEleicoes,setLocalidades,user);
        }

        if(!instanciaInfo || !FirestoreService.hasLocalidadesSubscribe()){
          FirestoreService.getLocalidades(mock,instancia,setLocalidades);
        }

        if(rotaVotacao && (!cargos?.length>0 || !FirestoreService.hasCargosSubscribe())){
          FirestoreService.getCargos(mock,instancia,setCargos);
        }

        if(rotaSecoes && (!locaisVotacao?.length>0 || !FirestoreService.hasLocaisVotacaoSubscribe())){
          FirestoreService.getLocaisVotacao(mock,instancia,setLocaisVotacao);
        }

        if((rotaSecoes || rotaAcompanhamento || rotaMapa) && (!zonasEleitorais?.length>0 || !FirestoreService.hasZonasEleitoraisSubscribe())){
          FirestoreService.getZonasEleitorais(mock,instancia,setZonasEleitorais);
        }
      }

    } catch( error){        
      console.error("App: Carga dados básicos: não foi possível conectar com o firebase");
      alert("Não foi possível carregar os dados Básicos da Aplicação")
      setLoading(false)
      navigate("/Error500")

    }           
  }, [instancia,routeName]); 

  //processa exibição com base na instancia
  useEffect(() => {       
    if(instanciaInfo && instanciaInfo?.onLine!=false){            
      //ajusta tema de exibição conforme situação instancia        
      if(instanciaInfo?.fase == "oficial"){                  
        carregaTemaOficial()        
      }
      if(instanciaInfo?.fase == "simulado" || instanciaInfo?.fase == "teste"){        
        //simulado e treinamento
        carregaTemaSimulado()
      }
    }    
  }, [instanciaInfo]);

  //processa o objecto de Pendencias
  useEffect(() => {
    if(rotaPendencias && user){     
      if(!pendencias?.length>0 || !FirestoreService.hasPendentesSubscribe()){
        FirestoreService.getPendentes(mock, instancia, setPendencias,setUser);      
      }
    }
  }, [instancia,rotaPendencias]);
  
  //processa o objecto de acompanhamento das Seções
  useEffect(() => {
    if(zonasEleitorais?.length>0 && (rotaSecoes||rotaAcompanhamento||rotaMapa) && instancia){      
      //Carrega o acompanhamento das seções de acompanhamento se está vazio ou não tem nenhuma subscriber cadastrado
      if(!acompanhamentoSecoes || !FirestoreService.hasAcompanhamentoSecoesSubscribe()){
      	FirestoreService.getAcompanhamentoSecoes(mock,instancia,zonasEleitorais,setAcompanhamentoSecoes).catch( error =>{        
          alert("Não foi possível carregar os dados de acompanhamento das seções")
          setLoading(false)
        })      
      }
    }
  }, [instancia,zonasEleitorais,rotaSecoes,rotaAcompanhamento,rotaMapa]);

  //processa a totalização
  useEffect(() => {    
    //verifica se os tres campos de seleção da Votacao estão selecionados e se tem uma inctancia carregada
    if(localidadeSelecionadaId && cargoSelecionadoId && instancia){
      //Carrega a totalização das seções se está vazio ou não tem nenhum subscriber cadastrado
      FirestoreService.getTotalizacao(mock,instancia,localidadeSelecionadaId,cargoSelecionadoId,setTotalizacao).catch( error =>{
        alert("Não foi possível carregar os dados da Votação")
        setLoading(false)
      })
    }else{
      //apagar totalização na deseleção de algum item
      setTotalizacao(undefined)
    }
  }, [instancia,localidadeSelecionadaId,cargoSelecionadoId]);  

  //processa as fotos da totalização
  useEffect(() => {    
    //Get codigo dos candidatos que estão na totalização
    totalizacao?.votosCandidatos?.forEach( cand =>{            
      //verifica se foto já foi carregada se não baixa a mesma do firestore
      let hasFoto = fotos?.some( fotoObj => Number(fotoObj?.idCandidato)===Number(cand?.codigo) );        
      if(cand?.codigo && !hasFoto){
        //baixa e adiciona a foto              
        FirestoreService.getFotoCandidatoByte64(mock,instancia, cand?.codigo).then( fotoObj =>  setFotos(current => [...current, fotoObj])).catch( error =>{
          console.error("App: "+ error)
        }); 
      }
    });
    
  }, [totalizacao]);

  // logout function
  const logout = () => {
    FirestoreService.logout(setUser).then(()=>{
      navigate("/login")
    })
  }  

  //Reset state das variaveis
  const resetState = () =>{
    //Reset local data
    setInstanciaInfo(null)
    setEleicoes([]);
    setLocalidades([]);
    setUfs([]);
    setCargos([]);
    setZonasEleitorais([]);
    setLocaisVotacao([]);
    //reset totalizações
    setTotalizacao();
    setAcompanhamentoSecoes();
    setPendencias();
    //reset filtros
    setLocalidadeSelecionadaId(null);
    setCargoSelecionadoId(null);
    setZonaESelecionadaId(null);
    setLocalVSelecionadoId(null);
  }

  const carregaTemaOficial = () =>{
    //official
    document.documentElement.style.setProperty('--app-color-main','#66aedb');
    document.documentElement.style.setProperty('--app-color-highlight','#519dcc');
    document.documentElement.style.setProperty('--app-color-shadow','#a0d2fa');
    document.documentElement.style.setProperty('--app-color-lidas','#519ece');
    document.documentElement.style.setProperty('--app-color-light','#cae6fc');
    document.documentElement.style.setProperty('--app-color-hover','#f4fafe');    
  }

  const carregaTemaSimulado = () =>{
    //simulado e treinamento
    document.documentElement.style.setProperty('--app-color-main','#8d60db');
    document.documentElement.style.setProperty('--app-color-highlight','#7e57c2');
    document.documentElement.style.setProperty('--app-color-shadow','#d4a2dd');
    document.documentElement.style.setProperty('--app-color-lidas','#7e57c2');
    document.documentElement.style.setProperty('--app-color-light','#e7cbec');
    document.documentElement.style.setProperty('--app-color-hover','#faf4fb');   
  }

    return(
      <AppContext.Provider value={{user, setUser, logout, 
          mock, instancia, setInstancia, instanciaInfo, setInstanciaInfo, 
          loading, setLoading, 
          rolagemAuto, setRolagemAuto,
          rolagemAutoIntervalo, setRolagemAutoIntervalo, 
          ordenaPorVoto, setOrdenaPorVoto, 
          ocultaLidas, setOcultaLidas, 
          ocultaNLidas, setOcultaNLidas, 
          ocultaZonasConcluidas, setOcultaZonasConcluidas,
          pendencias, setPendencias,
          totalizacao, setTotalizacao,
          acompanhamentoSecoes, setAcompanhamentoSecoes,  
          resetState,        
          eleicoes, localidades, ufs, cargos, zonasEleitorais, locaisVotacao, totalizacao, acompanhamentoSecoes, fotos,
          localidadeSelecionada, localidadeSelecionadaId, setLocalidadeSelecionadaId, 
          cargoSelecionado, cargoSelecionadoId, setCargoSelecionadoId, 
          zonaESelecionada, zonaESelecionadaId, setZonaESelecionadaId,
          localVSelecionado, localVSelecionadoId, setLocalVSelecionadoId}}>
        {props.children}
      </AppContext.Provider>    
    );
};
  
  export default AppContext;
